<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item
          v-if="reflashBtn"
          prefixIcon="icon hero-icon hero-icon-refresh"
          :tooltipText="$t('Common.refresh')"
          :click="notices"
          eventType="reflash"
        ></e-item>
        <e-item
          v-if="queryBtn"
          prefixIcon="icon hero-icon hero-icon-advanced-search"
          :tooltipText="$t('Common.adSearch')"
          :click="notices"
          eventType="query"
        ></e-item>
        <e-item
          v-if="exportBtn"
          prefixIcon="icon hero-icon hero-icon-export"
          :tooltipText="$t('Common.export')"
          :click="notices"
          eventType="export"
        ></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: "ToolBar",
  props: {
    reflashBtn: { type: Boolean, default: false },
    queryBtn: { type: Boolean, default: false },
    exportBtn: { type: Boolean, default: false }
  },
  data() {
    return {};
  },
  methods: {
    notices(args) {
      this.$emit("notice", args.item.eventType);
    }
  }
};
</script>
